// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.blockquote {\n\tpadding: 10px 10px;\n\tborder-left: 5px solid #aaaaff;\n}\n", ""]);
// Exports
module.exports = exports;
